import { tv } from "tailwind-variants";

export const getLoaderClass = tv({
  base: [
    "inline-block animate-spin rounded-full border-currentColor border-b-transparent border-solid",
    "size-[1em] border-[0.12em]",
  ],
});
